import { render, staticRenderFns } from "./ChatroomPage.vue?vue&type=template&id=0e9ad3db&scoped=true"
import script from "./ChatroomPage.vue?vue&type=script&lang=js"
export * from "./ChatroomPage.vue?vue&type=script&lang=js"
import style0 from "./ChatroomPage.vue?vue&type=style&index=0&id=0e9ad3db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9ad3db",
  null
  
)

export default component.exports